'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
import type { LiveEventSummary } from '@/components/live/types';
import { CopyableCashtagBadge } from '@/components/market/copyable-cashtag-badge';
import { Badge } from '@/components/ui/app-badge';
import { Icon } from '@/components/ui/icon';
import { Calendar03Icon, LiveStreaming02IconSolid } from '@/components/ui/icon/glyphs';
import { NavLink } from '@/components/ui/navigation-list';
import { cn } from '@/lib/ui/utils';
const TAG_TEXT_CLASS = 'text-foreground-tertiary';
function TagSeparator() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span aria-hidden="true" className={cn(TAG_TEXT_CLASS, "w-2.5 shrink-0 text-center")}>·</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function LiveMarketContext(t0) {
  const $ = _c(16);
  const {
    event,
    ticker
  } = t0;
  const tNav = useTranslations("nav");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Icon icon={LiveStreaming02IconSolid} className="size-3 shrink-0" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== tNav) {
    t2 = tNav("live");
    $[1] = tNav;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <Badge data-testid="live-market-kind" variant="secondary" className="gap-1 border-0 bg-outcome-red-fill text-outcome-red-text">{t1}{t2}</Badge>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <TagSeparator />;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `/live/${encodeURIComponent(event.id)}`;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Icon icon={Calendar03Icon} className="size-3.5 shrink-0" />;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== event.title || $[8] !== t5) {
    t7 = <NavLink href={t5} prefetch={false} className="gap-1 font-normal text-foreground-tertiary hover:text-foreground-brand">{t6}{event.title}</NavLink>;
    $[7] = event.title;
    $[8] = t5;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== ticker) {
    t8 = ticker !== null && ticker !== undefined && ticker !== "" ? <><TagSeparator /><CopyableCashtagBadge ticker={ticker} appearance="tag" /></> : null;
    $[10] = ticker;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t7 || $[14] !== t8) {
    t9 = <span data-testid="live-market-context" className="contents">{t3}{t4}{t7}{t8}</span>;
    $[12] = t3;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}